"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var react_1 = __importDefault(require("react"));
var LoadingContent_1 = __importDefault(require("components/Spinners/LoadingContent"));
var integrationsConnections_1 = require("utils/integrationsConnections");
var ReferralLanding = function (_a) {
    var match = _a.match;
    var referrer = match.params.referrer;
    react_1.default.useEffect(function () {
        if (referrer.toLowerCase() === 'xero') {
            var urlSearchParams = new URLSearchParams(window.location.search);
            var trackingProps = {
                realsource: window.location.search || 'N/A',
                searchParams: Object.fromEntries(urlSearchParams.entries()),
                source: 'xero-referral',
                product: 'RECHARGLY',
                creationFlow: "XERO".concat(end2end_1.IS_RECHARGLY ? '_RECHARGLY' : '', "_REFERRAL_SIGNUP"),
            };
            localStorage.accountCreationTracking = JSON.stringify(__assign(__assign({}, trackingProps), { authType: 'xero' }));
            window.location.href = (0, integrationsConnections_1.makeAuthorizeUri)((0, end2end_1.getXeroAuthorizeUriTemplate)('NONE', end2end_1.IS_RECHARGLY ? end2end_1.XERO_MAIN_RECHARGLY_CLIENT_ID : end2end_1.XERO_MAIN_CLIENT_ID, "SIGN-UP-REFERRAL".concat(end2end_1.IS_RECHARGLY ? '-RECHARGLY' : '')), '/', 'xero');
        }
    }, []);
    return (0, jsx_runtime_1.jsx)(LoadingContent_1.default, {});
};
exports.default = ReferralLanding;
